import { render, staticRenderFns } from "./ContentTabs.vue?vue&type=template&id=f6f16a18&scoped=true&"
import script from "./ContentTabs.vue?vue&type=script&lang=js&"
export * from "./ContentTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f16a18",
  null
  
)

export default component.exports